module.exports = __webpack_public_path__ + "img/brandDefaultPicture.0b65ac34.svg";